import module from "./module";
import { buildUrl } from "#/utils/api";
module.service("StartupProgressService", function($q) {
  "ngInject";
  "use strict";
  
  this.status = function() {
    const url = buildUrl("status");
    return $q(function(resolve, reject) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {          
          if (xhr.status === 503 || xhr.status === 200) {
            try {
              resolve(JSON.parse(xhr.responseText));
            } catch (e) {
              resolve({
                results: {
                  EventStoreSubscription: {
                    data: {
                      EventStoreConnectionStatus: {
                        IsLive: false,
                        CatchupProgress: { CatchupPercentage: 0 }
                      }
                    }
                  }
                }
              });
            }
          } else {
            reject(new Error('HTTP ' + xhr.status + ': ' + xhr.statusText));
          }
        }
      };
      xhr.onerror = function() {
        reject(new Error('Network error'));
      };
      xhr.send();
    });
  };
});